import { useRef } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoReplay from '@/components/UI/svg/Icons/EFVideoReplay';

export default function GsapD2() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('smarthomepanel');
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['jp', 'fr', 'de']);
    const videoRef = useRef(null);

    return (
        <div className={`${css.gsapD} gsapD2`}>
            <div className="box-l">
                <div className="box-l-inter">
                    <span className="msg-color1">{t('smart_home_panel.ten_text1_pc1')}</span>
                    {t('smart_home_panel.ten_text1_pc2')}
                    <span className="msg-color1">{t('smart_home_panel.ten_text1_pc3')}</span>
                </div>
            </div>
            <div className="box-r">
                <EFVideo
                    ref={videoRef}
                    sources={[`/video/smarthomepanel/phone_video2_${imgLocal}.webm`, `/video/smarthomepanel/phone_video2_${imgLocal}.mp4`]}
                    className="video"
                    loop={false}
                />
                <span className="btn-video-play" onClick={() => videoRef.current?.play()}>
                    <EFVideoReplay />
                </span>
            </div>
        </div>
    );
}
